module.exports = __webpack_public_path__ + "static/media/hall-P7.12609627.svg";